import { friendlySdgAlignmentLevel } from '@upright/common/model/input/sdg-alignment/friendly';
import { toSdgAlignmentLevel } from '@upright/common/model/output/scores/sdg-alignment/utils';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled from 'styled-components';
import {
  SdgAlignmentStrength,
  SdgAlignmentValence,
} from '../../../../../../../../common/model/output/scores/sdg-alignment/types';
import { useSdgAlignmentsContext } from '../context';
import { getSdgColor } from '../shared';

interface Props {
  valence: SdgAlignmentValence;
}

export const SdgLegendItems = (props: Props) => {
  return props.valence === SdgAlignmentValence.ALIGNED ? (
    <>
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.STRONG }} />
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.NORMAL }} />
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.WEAK }} />
    </>
  ) : (
    <>
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.WEAK }} />
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.NORMAL }} />
      <SdgLegendItem {...{ valence: props.valence, strength: SdgAlignmentStrength.STRONG }} />
    </>
  );
};

interface SingleItemProps extends Props {
  strength: SdgAlignmentStrength;
}

const SdgLegendItem = (props: SingleItemProps) => {
  const hideBorder = !!useSdgAlignmentsContext().viewOptions.hideLegendBorders;

  return (
    <ItemRoot>
      <ItemInner hideBorder={hideBorder}>
        <ColorBox {...props} />
        <LegendText>{friendlySdgAlignmentLevel(toSdgAlignmentLevel(props.valence, props.strength))}</LegendText>
      </ItemInner>
    </ItemRoot>
  );
};

const ItemRoot = styled.div`
  padding-left: 0.4em;
  padding-right: 0.4em;
  padding-top: 0.4em;
  padding-bottom: 0.4em;

  flex-shrink: 1;
  flex-grow: 1;

  flex-basis: 100%;
  @media (min-width: 370px) {
    flex-basis: 50%;
  }
  @media (min-width: 700px) {
    flex-basis: 30.3%;
  }
  @media (min-width: 900px) {
    flex-basis: 16.5%;
  }
`;

const ItemInner = styled.div<{ hideBorder: boolean }>`
  display: flex;
  align-items: baseline;

  > * + * {
    margin-left: 0.7em;
  }

  border: ${props => !props.hideBorder && `1px solid ${BouColor.TOOL_TABLE_BACKGROUND_LIGHT_GRAY}`};
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  padding-left: 0.3em;
  padding-right: 0.3em;
`;

const ColorBox = styled.div<SingleItemProps>`
  background-color: ${props => getSdgColor(props.valence, props.strength)};
  width: 0.7em;
  height: 0.7em;
  flex-shrink: 0;
  flex-grow: 0;
`;

const LegendText = styled.div`
  white-space: nowrap;
`;
